export interface IFilterOption {
  column: FilterColumnTypes;
  name: string;
  value: string | boolean;
  label: string;
  showChipEvenFalse?: boolean;
}
export enum FilterColumnTypes {
  STATUS = "STATUS",
  VESSEL = "VESSEL",
  ADR = "ADR",
  POD = "POD",
  CUSTOMERNAME = "CUSTOMERNAME",
}
export enum IStatus {
  NEW = "NEW",
  CREATEDINSIMPLY = "CREATEDINSIMPLY",
  SENTTOSIMPLY = "SENTTOSIMPLY",
}
export enum IAdr {
  YES = "YES",
  NO = "NO",
}
export function getStatusValue(status: IStatus): number {
  switch (status) {
    case IStatus.NEW:
      return 1;
    case IStatus.CREATEDINSIMPLY:
      return 2;
    case IStatus.SENTTOSIMPLY:
      return 3;
    default:
      return 0; // default return value if status is not recognized
  }
}
